export const CLIENT_LABEL_MAPPING = {
    'SobrenomeContato': 'Cliente',
    'PrimeiroNomeContato': 'Nome do respom.',
    'EnderecoCobranca': 'Endereço',
    'EstadoProvincia': 'Data RG',
    'Pais': 'CGC.',
    'Fax': 'Fax/Cel',
    'NomeEmpresa': 'ADM',
    'TituloContato': 'Outros',
    // Adicionais para garantir que não fiquem vazios ou estranhos se houver variação de case
    'sobrenomecontato': 'Cliente',
    'primeironomecontato': 'Nome do respom.',
};

export const getClientLabel = (key) => CLIENT_LABEL_MAPPING[key] || key;
